import * as style from '../../utils/general_style.js';

function RoundRadio({ label, name, id, onChange, value, isSelected }) {

	return (
        <div style={{...style.ROW, margin: `0px ${style.SPACE.small} 0px 0px`}}>
            <input id={ id } name={ name } onChange={ onChange } value={ value } type="radio" checked={ isSelected } />
            <label htmlFor={ id } style={{cursor: 'pointer'}}>
                <i className={(isSelected) ? "fa-regular fa-circle-dot" : "fa-regular fa-circle"} style={{fontSize: '20px', color: style.COLORS.primary, margin: `0px ${style.SPACE.extraSmall} 0px 0px`, position: 'relative', top: '2px'}}></i>
                { label }
            </label>
        </div>
	);
};

export default RoundRadio;